import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem 0;
  div {
    display: flex;
    align-items: center;
    width: 100%;
    img {
      margin: 1rem;
      border-radius: 10px;
    }
    span {
      margin: 1rem;
      font-weight: bold;
    }
  }
`;

const Number = styled.span`
  background: ${({ number }) =>
    number === 0 ? 'hsl(0, 0%, 92%)' : 'hsl(9, 48%, 95%)'};
  color: ${({ number }) =>
    number === 0 ? 'hsl(0, 0%, 65%)' : 'hsl(0, 79%, 72%)'};
  border-radius: 1rem;
  padding: 0.4rem;
  font-size: 0.9rem;
  font-weight: 550;
`;

export { Number };

export default Container;
